import React from 'react';
import { Link } from 'react-router-dom';
import './Hosting.css';

const Hosting = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const hostingTypes = [
    {
      icon: '🖥️',
      title: 'هاست cPanel ایران',
      desc: 'میزبانی وب با کنترل پنل cPanel و سرورهای قدرتمند در داخل ایران. مناسب برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و کسب‌وکارهای ایرانی با نیاز به سرعت بالا و پینگ پایین. هاست cPanel ایران با پشتیبانی کامل از زبان فارسی و قوانین داخلی، گزینه‌ای ایده‌آل برای وب‌سایت‌های مخاطب ایرانی است.',
      features: ['سرورهای NVMe', 'cPanel + LiteSpeed', 'پشتیبانی ۲۴/۷', 'بکاپ خودکار'],
      link: '/hosting/cpanel-iran',
      color: '#06B6D4',
    },
    {
      icon: '🌐',
      title: 'هاست cPanel خارج',
      desc: 'میزبانی وب با کنترل پنل cPanel روی سرورهای اروپایی (هلند و آلمان). مناسب برای وب‌سایت‌های بین‌المللی، کسب‌وکارهای صادراتی و پروژه‌هایی که نیاز به دیتاسنتر خارج از ایران دارند. هاست cPanel خارج با پهنای باند بالا و آپتایم تضمینی، انتخابی عالی برای مخاطبان جهانی است.',
      features: ['لوکیشن هلند/آلمان', 'cPanel + CloudLinux', 'SSL رایگان', 'پشتیبانی ۲۴/۷'],
      link: '/hosting/cpanel-foreign',
      color: '#F97316',
    },
    {
      icon: '🐧',
      title: 'هاست لینوکس',
      desc: 'میزبانی وب بر روی سرورهای لینوکس با کنترل پنل‌های محبوب مانند cPanel و DirectAdmin. مناسب برای توسعه‌دهندگان، برنامه‌نویسان و وب‌سایت‌های مبتنی بر PHP، Python، Node.js و Ruby. هاست لینوکس با انعطاف‌پذیری بالا و امنیت عالی، گزینه‌ای ایده‌آل برای پروژه‌های متنوع است.',
      features: ['سیستم‌عامل لینوکس', 'پشتیبانی از PHP/Python', 'Root Access', 'پشتیبانی ۲۴/۷'],
      link: '/hosting/linux',
      color: '#8B5CF6',
    },
    {
      icon: '🪟',
      title: 'هاست ویندوز',
      desc: 'میزبانی وب بر روی سرورهای ویندوز با پشتیبانی از ASP.NET، MSSQL و سایر فناوری‌های مایکروسافت. مناسب برای وب‌سایت‌های سازمانی، اپلیکیشن‌های دات‌نت و پروژه‌هایی که به محیط ویندوز نیاز دارند. (به زودی)',
      features: ['ASP.NET Core', 'MSSQL Database', 'Plesk Control Panel', 'پشتیبانی ۲۴/۷'],
      link: '/hosting/windows',
      color: '#3B82F6',
      soon: true,
    },
    {
      icon: '🔧',
      title: 'هاست DirectAdmin',
      desc: 'میزبانی وب با کنترل پنل DirectAdmin، یک جایگزین سبک، سریع و مقرون‌به‌صرفه برای cPanel. مناسب برای وب‌سایت‌هایی که به دنبال کنترل پنلی ساده و کارآمد با منابع مصرفی کمتر هستند. هاست DirectAdmin با قیمت مناسب و عملکرد بالا، گزینه‌ای عالی برای کسب‌وکارهای کوچک و متوسط است.',
      features: ['کنترل پنل DirectAdmin', 'منبع‌مصرف کم', 'قیمت مناسب', 'پشتیبانی ۲۴/۷'],
      link: '/hosting/directadmin',
      color: '#EC4899',
    },
    {
      icon: '📝',
      title: 'هاست وردپرس',
      desc: 'میزبانی تخصصی و بهینه‌شده برای وب‌سایت‌های وردپرسی با سرورهای NVMe، کش پیشرفته و CDN. مناسب برای وبلاگ‌ها، فروشگاه‌های ووکامرس، وب‌سایت‌های شرکتی و هر پروژه وردپرسی. هاست وردپرس با بهینه‌سازی‌های ویژه، سرعت بارگذاری بالا و امنیت عالی را برای شما به ارمغان می‌آورد.',
      features: ['بهینه‌سازی وردپرس', 'LiteSpeed + Redis', 'نصب یک‌کلیک', 'پشتیبانی ۲۴/۷'],
      link: '/hosting/wordpress',
      color: '#22C55E',
    },
  ];

  const faqs = [
    {
      q: 'تفاوت هاست cPanel ایران و خارج در چیست و کدام یک برای من مناسب‌تر است؟',
      a: 'هاست cPanel ایران روی سرورهای داخل کشور قرار دارد و برای وب‌سایت‌هایی که مخاطب اصلی آنها ایرانی است، سرعت و پینگ بسیار بهتری دارد. همچنین با قوانین داخلی سازگار است. هاست cPanel خارج روی سرورهای اروپایی (هلند یا آلمان) قرار دارد و برای وب‌سایت‌های بین‌المللی یا پروژه‌هایی که محدودیت‌های داخلی دارند، مناسب‌تر است. انتخاب شما بستگی به مخاطب هدف و نیازهای پروژه شما دارد. بسیاری از کسب‌وکارها از هر دو نوع هاست استفاده می‌کنند تا پوشش کامل داشته باشند.',
    },
    {
      q: 'هاست لینوکس چه مزایایی دارد و با چه زبان‌های برنامه‌نویسی سازگار است؟',
      a: 'هاست لینوکس به دلیل پایداری بالا، امنیت عالی و هزینه کمتر نسبت به ویندوز، محبوب‌ترین انتخاب برای میزبانی وب است. این نوع هاست با زبان‌های برنامه‌نویسی مانند PHP، Python، Node.js، Ruby، Perl و بسیاری دیگر سازگار است. همچنین پایگاه‌های داده MySQL، MariaDB و PostgreSQL را پشتیبانی می‌کند. هاست لینوکس برای اکثر وب‌سایت‌ها، فروشگاه‌های آنلاین و اپلیکیشن‌های وب گزینه‌ای ایده‌آل است.',
    },
    {
      q: 'هاست وردپرس چه تفاوتی با هاست معمولی دارد و چرا باید از آن استفاده کنم؟',
      a: 'هاست وردپرس به طور ویژه برای وب‌سایت‌های وردپرسی بهینه‌سازی شده است. این نوع هاست شامل کش پیشرفته (LiteSpeed Cache)، CDN، بهینه‌سازی پایگاه داده، امنیت ویژه و نصب یک‌کلیک وردپرس می‌شود. سرعت بارگذاری صفحات وردپرسی در هاست تخصصی به طور قابل توجهی بالاتر است و تجربه کاربری بهتری را برای بازدیدکنندگان شما فراهم می‌کند. اگر وب‌سایت شما با وردپرس ساخته شده است، هاست وردپرس بهترین انتخاب برای شماست.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>خرید هاست | هاست cPanel ایران و خارج، هاست لینوکس، وردپرس و DirectAdmin | افرسل</h1>
        <p>خرید هاست با بهترین قیمت از افرسل. هاست cPanel ایران و خارج، هاست لینوکس، هاست ویندوز، هاست DirectAdmin و هاست وردپرس. پشتیبانی ۲۴ ساعته، آپتایم ۹۹.۹٪ و قیمت‌های رقابتی.</p>
        <meta name="description" content="خرید هاست با بهترین قیمت از افرسل. انواع هاست cPanel ایران و خارج، هاست لینوکس، هاست ویندوز، هاست DirectAdmin و هاست وردپرس. پشتیبانی ۲۴/۷، آپتایم ۹۹.۹٪." />
      </div>

      <section className="hosting-main-hero">
        <div className="hosting-main-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-main-hero-content">
            <div className="hosting-main-badge">
              <span className="pulse-dot"></span>
              🚀 میزبانی وب حرفه‌ای
            </div>
            <h1 className="hosting-main-hero-title">
              هاست <em>مناسب</em> کسب‌وکار خود را انتخاب کنید
            </h1>
            <p className="hosting-main-hero-desc">
              از هاست اشتراکی تا هاست تخصصی وردپرس، همه خدمات میزبانی وب با بهترین کیفیت و قیمت. 
              سرورهای NVMe، کنترل پنل‌های حرفه‌ای، پشتیبانی ۲۴ ساعته و آپتایم ۹۹.۹٪ تضمینی.
              با انتخاب هاست مناسب، کسب‌وکار خود را به سطح بالاتری ببرید.
            </p>
            <div className="hosting-main-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۶+</span>
                <span className="stat-label">نوع هاست</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۹۹.۹٪</span>
                <span className="stat-label">آپتایم تضمینی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-types">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">خدمات هاستینگ</span>
            <h2 className="sec-h">انواع هاست <em>مناسب</em> هر پروژه</h2>
            <p className="sec-p">از هاست اشتراکی تا هاست تخصصی، همه خدمات میزبانی وب با بهترین کیفیت و قیمت در افرسل.</p>
          </div>
          <div className="hosting-types-grid">
            {hostingTypes.map((type, i) => (
              <Link to={type.link} key={i} className={`hosting-type-card ${type.soon ? 'soon' : ''}`}>
                {type.soon && <span className="hosting-soon-badge">به زودی</span>}
                <span className="hosting-type-icon">{type.icon}</span>
                <h3 className="hosting-type-title">{type.title}</h3>
                <p className="hosting-type-desc">{type.desc}</p>
                <ul className="hosting-type-features">
                  {type.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="hosting-type-link" style={{ color: type.color }}>
                  مشاهده پلن‌ها ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-main-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره خرید هاست و خدمات میزبانی وب.</p>
          </div>
          <div className="hosting-main-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-main-faq-item">
                <div className="hosting-main-faq-q">{faq.q}</div>
                <div className="hosting-main-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-main-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>مناسب</em> خود را انتخاب کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست از افرسل، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
              انتخاب از بین انواع هاست با بهترین قیمت‌ها و شرایط ویژه.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
              <button className="btn-lg ghost" onClick={() => {
                const el = document.querySelector('.hosting-types-grid');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                مشاهده پلن‌ها
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hosting;
